import { useState } from "react";
import { Table } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";

import { useGetTemplates } from "api/queries/user/useGetTemplates";
import { IUserTemplate } from "types/Common";
import ExpandableSearch from "components/atoms/ExpandableSearch/ExpandableSearch";
import PillTabs from "components/atoms/PillTabs/PillTabs";
import ViewTemplateDialog from "./ViewTemplateDialog";
import "./PresetsAndTemplates.scss";

const TemplatesTable = function () {
  const intl = useIntl();
  const [templateType, setTemplateType] = useState<"quote_request_templates" | "quick_request_templates">(
    "quick_request_templates",
  );
  const [selectedTemplate, setSelectedTemplate] = useState<IUserTemplate>();
  const [wiewTemplateDialog, showWiewTemplateDialog] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const { data: templatesData, isFetching: isFetchingTemplates } = useGetTemplates({
    refetchOnMount: false,
  });

  const handleClickRow = (template: IUserTemplate) => () => {
    setSelectedTemplate(template);
    showWiewTemplateDialog(true);
  };

  const filteredData: IUserTemplate[] = templatesData?.[templateType]
    ? searchValue
      ? templatesData?.[templateType].filter((template) => template.label.toLowerCase().includes(searchValue.toLowerCase()))
      : templatesData?.[templateType]
    : [];

  return (
    <>
      <ViewTemplateDialog
        isOpen={wiewTemplateDialog}
        close={() => showWiewTemplateDialog(false)}
        selectedTemplate={selectedTemplate}
        templateType={templateType}
      />
      <div className="data-table mt-5" style={{ maxHeight: "700px", overflow: "auto" }}>
        <div className="d-flex align-items-center mt-4 mb-4">
          <div className="font-weight-bold" style={{ fontSize: "24px" }}>
            <FormattedMessage id="settings.templates" defaultMessage="Templates" />
          </div>
          <div className="ml-3" style={{ width: "fit-content" }}>
            <ExpandableSearch
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
              }}
            />
          </div>
        </div>

        <PillTabs
          id="template-settings-tabs"
          activeKey={templateType}
          onSelect={(eventKey: any) => setTemplateType(eventKey)}
          tabItems={[
            {
              eventKey: "quick_request_templates",
              title: intl.formatMessage({
                id: "settings.templates.quickRequestTemplates",
                defaultMessage: "Quick request templates",
              }),
            },
            {
              eventKey: "quote_request_templates",
              title: intl.formatMessage({
                id: "settings.templates.quoteRequestTemplates",
                defaultMessage: "Quote request templates",
              }),
            },
          ]}
        />
        <Table bordered size="sm" className="mt-4">
          <thead>
            <tr>
              <th>
                <FormattedMessage id="settings.templates.templateName" defaultMessage="Template name" />
              </th>
            </tr>
          </thead>
          <tbody>
            {isFetchingTemplates ? (
              <Loader />
            ) : (
              <>
                {filteredData.length === 0 ? (
                  <tr>
                    <td>
                      <FormattedMessage id="settings.templates.noTemplatesFound" defaultMessage="No templates found" />
                    </td>
                  </tr>
                ) : (
                  filteredData?.map((template) => (
                    <tr className="filter-row" key={template.reference_number} onClick={handleClickRow(template)}>
                      <td>{template.label}</td>
                    </tr>
                  ))
                )}
              </>
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
};

function Loader() {
  return (
    <>
      <tr>
        <td>
          <div className="skeleton" />
        </td>
        <td>
          <div className="skeleton" />
        </td>
      </tr>
      <tr>
        <td>
          <div className="skeleton" />
        </td>
        <td>
          <div className="skeleton" />
        </td>
      </tr>
      <tr>
        <td>
          <div className="skeleton" />
        </td>
        <td>
          <div className="skeleton" />
        </td>
      </tr>
    </>
  );
}

export default TemplatesTable;
